import { Component, Input } from '@angular/core';

import { UiPalette } from '../../../types/UiPalette.type';

@Component({
  selector: 'eiq-state-card',
  templateUrl: 'state-card.component.html',
  styleUrls: ['./state-card.component.scss']
})
export class StateCardComponent {
  @Input() name: string;
  @Input() primaryColor: UiPalette | undefined = undefined;
  @Input() secondaryColor: UiPalette | undefined = undefined;
  @Input() value: string | number;
}
